import LogoComponent from './LogoComponent.jsx';
import NavigationComponent from './NavigationComponent.jsx';
import SettingsComponent from './SettingsComponent.jsx';

import './Header.css';

function Header() {
    return (
        <header className="top-bar">
            <LogoComponent />
            <NavigationComponent />
            <SettingsComponent />
        </header>
    );
}

export default Header;